import DoAPICall from './DoAPICall'

//Get All Analytics

export async function getSummaryDashboard(userToken,theMonth){
   const apiPayload = {
      httpMethod:'get',
      userToken,
      uri:'summarydashboard?theMonth='+theMonth,
      payLoad:{},
      requestOptions:{}
   }
   return await DoAPICall(apiPayload)
}

export async function getMainDashboard(userToken,params){
   const apiPayload = {
      httpMethod:'get',
      userToken,
      uri:'maindashboard?client_id='+params.client_id+'&dateFrom='+params.from+'&dateTo='+params.to,
      payLoad:{},
      requestOptions:{}
   }
   return await DoAPICall(apiPayload)
}

export async function getDayDashboard(userToken,params){
   const apiPayload = {
      httpMethod:'get',
      userToken,
      uri:'daydashboard?client_id='+params.client_id+'&theDate='+params.theDate,
      payLoad:{},
      requestOptions:{}
   }
   return await DoAPICall(apiPayload)
}

export async function getUserDashboard(userToken,params){
   const apiPayload = {
      httpMethod:'get',
      userToken,
      uri:'userdashboard?client_id='+params.client_id+'&dateFrom='+params.from+
               '&dateTo='+params.to+'&revenueCollectorCode='+params.revenueCollectorCode,
      payLoad:{},
      requestOptions:{}
   }
   return await DoAPICall(apiPayload)
}